import { action, makeAutoObservable, observable, reaction, toJS } from "mobx";
import { loadDataHelper } from "./storeHelpers";
import { validationContext } from "validx";
import { supportMessageReplyValidationSchema } from "./validationSchemas/supportMessageReplyValidationSchema";
import { supportMessageValidationSchema } from "./validationSchemas/supportMessageValidationSchema";
import { contactMessageValidationSchema } from "./validationSchemas/contactMessageValidationSchema";
import Agent from "env/agent";

import { StoreBaseMethods } from "./storeBase";

const replyValidation = validationContext();
const messageValidation = validationContext();
const contactMessageValidation = validationContext();
class SupportStore  {
  host = null
  constructor({ data, host, authTokens } = {}) {
    makeAutoObservable(this, undefined, {autoBind: true});
    StoreBaseMethods.copyData(data, this);

    this.host = host || data?.host;
    this.authTokens = authTokens;

    reaction(
      () => toJS(this.reply),
      (reply) => {
        this.replyValidation = replyValidation
          .reset()
          .validate(reply, supportMessageReplyValidationSchema(reply));
      }
    );

    reaction(
      () => toJS(this.newMessage),
      (newMessage) => {
        this.messageValidation = messageValidation
          .reset()
          .validate(newMessage, supportMessageValidationSchema(newMessage));
      }
    );

    reaction(
      () => toJS(this.newContactMessage),
      (newContactMessage) => {
        if (this.isSubmittingNewContactMessage) return;

        this.newContactMessageValidation = contactMessageValidation
          .reset()
          .validate(
            newContactMessage,
            contactMessageValidationSchema(newContactMessage)
          );
      }
    );
  }

  get agent() {
    return new Agent(this.host, this.authTokens);
  }

  @action configureHost(hostname) {
    this.host = hostname;
  }
  @observable newContactMessageValidation = { errors: [] };
  @observable newContactMessage = {};

  @observable isSubmittingNewContactMessage = false;
  @action submitNewContactMessage({
    recaptcha,
    utm_source,
    utm_medium,
    utm_campaign,
    utm_content,
    utm_term,
  }) {
    this.isSubmittingNewContactMessage = true;
    return this.agent
      .Support.submitNewContactMessage({
        recaptcha,
        utm_source,
        utm_medium,
        utm_campaign,
        utm_content,
        utm_term,
        ...this.newContactMessage,
      })
      .then(
        action((data) => {
          if (data && data.ErrorMessage) {
            var err = new Error();
            err.data = data;
            throw err;
          }
          this.newContactMessage = {};
          return data;
        })
      )
      .finally(
        action(() => {
          this.isSubmittingNewContactMessage = false;
        })
      );
  }

  @observable newMessage = {};
  @action createNewMessage() {
    this.newMessage = {};
  }

  @observable isSubmittingNewMessage = false;
  @action submitNewMessage() {
    this.isSubmittingNewMessage = true;
    return this.agent
      .Support.submitNewMessage(this.newMessage)
      .then((data) => {
        if (data && data.ErrorMessage) {
          var err = new Error();
          err.data = data;
          throw err;
        }
        return data;
      })
      .finally(
        action(() => {
          this.isSubmittingNewMessage = false;
        })
      );
  }

  @observable reply = {};
  @observable replyValidation = { errors: [] };
  @observable messageValidation = { errors: [] };

  @observable isLoadingDepartments = false;
  @observable hasLoadedDepartments = false;
  @observable departments = [];
  @action loadDepartments() {
    return loadDataHelper({
      store: this,
      agentKey: 'Support',
      key: 'Departments',
      path: 'Departments',
    });
  }

  @observable isLoadingMessages = false;
  @observable hasLoadedMessages = false;
  @observable messages = [];
  @action loadMessages() {
    return loadDataHelper({
      store: this,
      agentKey: 'Support',
      key: 'Messages',
      path: 'Messages',
    });
  }

  @observable isLoadingMessage = false;
  @observable hasLoadedMessage = false;
  @observable message = null;
  @action loadMessage(id) {
    return loadDataHelper({
      store: this,
      agentKey: 'Support',
      key: 'Message',
      params: id,
    });
  }

  @observable isClosingRequest = false;
  @action closeRequest(id) {
    this.isClosingRequest = true;
    return this.agent
      .Support.closeRequest(id)
      .then((data) => {
        if (data && data.ErrorMessage) {
          var err = new Error();
          err.data = data;
          throw err;
        }
        return data;
      })
      .finally(
        action(() => {
          this.isClosingRequest = false;
        })
      );
  }

  @observable isSubmittingReply = false;
  @action submitReply() {
    this.isSubmittingReply = true;
    this.reply.HelpDeskMessage = this.message.Message.Id;
    return this.agent
      .Support.submitReply(this.reply)
      .then((data) => {
        if (data && data.ErrorMessage) {
          var err = new Error();
          err.data = data;
          throw err;
        }
        action(() => {
          this.reply.MessageText = null;
        })();
        return data;
      })
      .finally(
        action(() => {
          this.isSubmittingReply = false;
        })
      );
  }
}
export default SupportStore;
